export { default } from './SiteLogoDropZone';
